import { useGetFetch } from '../../utils/reactQuery';
import { pathToUrl } from '../../utils/router';
import { ApiRoutesEnum } from '../../utils/routes';
import { CandidateAiReviewStateType } from '../candidates/Candidates.types';

export const useGetCandidateAiReviewState = (id?: string) =>
  useGetFetch<CandidateAiReviewStateType>({
    url: id ? pathToUrl(ApiRoutesEnum.getCandidateAiReviewState, { id }) : '',
  });
